import axios from 'axios';
import { API_PATIENTS, API_REQ_HEADER } from '../config';


// eslint-disable-next-line import/prefer-default-export
export const getById = async (id) => {
    const res = await axios.get(`${API_PATIENTS}/${id}`, API_REQ_HEADER);
    return res.data;
};
